import { useRef } from 'react';
import type React from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

import { Text } from '@change-corgi/design-system-legacy/typography';

import { CustomFileInput } from './CustomFileInput';

type Props = {
	uppy: Uppy<Meta, Body>;
	fileInputId: string;
	onButtonClick?: () => void;
	uploadButtonText?: string;
	buttonTheme?: 'gray';
	buttonSize?: 'small';
};

type FileInputLabelButtonProps = {
	readonly buttonTheme?: 'gray';
};

const FileInputLabelButtonStyles = (props: FileInputLabelButtonProps) => ({
	fontWeight: 'bold',
	borderStyle: 'solid',
	borderWidth: '1px',
	borderRadius: '8px',
	height: '44px',
	cursor: 'pointer',
	padding: '9px 23px',
	color: props.buttonTheme === 'gray' ? 'primary-black' : 'primary-changeRed',
	borderColor: props.buttonTheme === 'gray' ? 'neutral-grey600' : 'primary-changeRed',
	display: 'flex',
	justifyContent: 'center',
	flexDirection: 'column' as const,
	alignItems: 'center',
	'&:focus, &:active, &:hover': {
		borderColor: props.buttonTheme === 'gray' ? 'primary-black' : 'primary-changeRed',
		borderWidth: '2px',
		padding: '8px 22px',
	},
});

export const AccessibleFileInputWrapper: React.FC<Props> = ({
	uppy,
	fileInputId,
	onButtonClick,
	uploadButtonText = 'Upload',
	buttonTheme,
	buttonSize,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);

	return (
		<>
			<CustomFileInput inputFileRef={inputRef} onButtonClick={onButtonClick} fileInputId={fileInputId} uppy={uppy} />
			<button
				type="button"
				onClick={() => inputRef.current?.click()}
				sx={{ ...FileInputLabelButtonStyles({ buttonTheme }) }}
			>
				<Text size={buttonSize === 'small' ? 'default' : 'large'}>{uploadButtonText}</Text>
			</button>
		</>
	);
};
